import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { enqueueSnackbar } from 'notistack';
import { PutFetch } from '../../../../services/apiBase';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import axios from 'axios';
import moment from 'moment';

export default function EditModal({ agreement, setTradeAgreementToEdit, onClose, getList, table, lastIpca }) {
  const user = JSON.parse(localStorage.getItem('user'));

  const [load, setLoad] = useState(false);

  const handleEditValues = async (e) => {
    const key = e.target.id;
    const value = e.target.value;
    console.log('VALUE: ', key);
    setTradeAgreementToEdit({ ...agreement, [key]: value });
  }

  const handleOnCloseModal = () => {
    onClose();
  }

  const handleSaveEditedValues = async (e) => {
    setLoad(true);
    handleSetFactor()
    try {
      //const response = await axios.put(`http://localhost:4600/financial/indicators?indicator=${table}`, {...agreement, username: user.username});
      const response = await PutFetch(`/financial/indicators?indicator=${table}`, { ...agreement, username: user.username });
      getList();
      handleOnCloseModal();
      enqueueSnackbar('Alteração salva com sucesso!', { variant: 'success' });

      return;
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(false);
    }
  }

  function handleChangeDate(value) {
    let data = new Date(value);
    data = moment.utc(data).format('YYYY-MM-DD');
    return data;
  }

  function handleSetType(value) {
    if (value === 'ATUAL') {
      agreement.financial_indicator_id = 6;
    } else {
      agreement.financial_indicator_id = 7;
    }
  }


  function handleSetFactor() {
    // console.log('---------handleSetFactor')
    // console.log('ANTES', agreement.factor)
    // console.log(agreement.value_rate)

    if (lastIpca > 0) {
      agreement.factor = ((1 + Number(agreement.value_rate)) * Number(lastIpca)).toFixed(6);
    } else {
      agreement.factor = 0;
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Editar indicador
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>
        {agreement.name ?
          <>
            <FormControl fullWidth>
              <DatePicker
                id={`date_rate`}
                label="Date Rate"
                type="date"
                value={dayjs(handleChangeDate(agreement.date_rate))}
                format='DD/MM/YYYY'
                onChange={(event) => {
                  setTradeAgreementToEdit({ ...agreement, date_rate: handleChangeDate(event) })
                }}
              />
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="value_rate">Taxa</InputLabel>
              <OutlinedInput
                id={`value_rate`}
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                label="Taxa"
                value={agreement.value_rate}
                onChange={(event) => {
                  handleEditValues(event);
                }}
              />
            </FormControl>

            {table === 'IPCA_FUTURO' ?
              <FormControl fullWidth>
                <InputLabel >Selecione o tipo</InputLabel>
                <Select
                  id="agreement.type"
                  label="Selecione o tipo"
                  value={agreement.type}
                  onChange={event => {
                    handleSetType(event.target.value);
                    setTradeAgreementToEdit({ ...agreement, type: event.target.value });
                  }}
                >
                  <MenuItem value={'ATUAL'}>Atual</MenuItem>
                  <MenuItem value={'FUTURO'}>Futuro</MenuItem>
                </Select>
              </FormControl>
              :
              null
            }

          </>
          :
          <>
            <FormControl fullWidth>
              <DatePicker
                id={`published_at`}
                label="Publicado"
                type="date"
                value={dayjs(handleChangeDate(agreement.published_at))}
                format='DD/MM/YYYY'
                onChange={(event) => {
                  setTradeAgreementToEdit({ ...agreement, published_at: handleChangeDate(event) })
                }}
              />
            </FormControl>
            <Box
              sx={{
                display: 'flex'
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="ipca_four_weeks">IPCA 4W</InputLabel>
                <OutlinedInput
                  id={`ipca_four_weeks`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="IPCA 4W"
                  value={agreement.ipca_four_weeks}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="ipca_one_week">IPCA 1W</InputLabel>
                <OutlinedInput
                  id={`ipca_one_week`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="IPCA 1W"
                  value={agreement.ipca_one_week}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="ipca_today">IPCA Hoje</InputLabel>
                <OutlinedInput
                  id={`ipca_today`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="IPCA Hoje"
                  value={agreement.ipca_today}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
            </Box>

            <Box
              sx={{
                display: 'flex'
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="selic_four_weeks">SELIC 4W</InputLabel>
                <OutlinedInput
                  id={`selic_four_weeks`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="SELIC 4W"
                  value={agreement.selic_four_weeks}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="SELIC_one_week">SELIC 1W</InputLabel>
                <OutlinedInput
                  id={`selic_one_week`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="SELIC 1W"
                  value={agreement.selic_one_week}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="selic_today">SELIC Hoje</InputLabel>
                <OutlinedInput
                  id={`selic_today`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="SELIC Hoje"
                  value={agreement.selic_today}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
            </Box>
            <Box
              sx={{
                display: 'flex'
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="exchange_rate_brlusd_four_weeks">Câmbio USD 4W</InputLabel>
                <OutlinedInput
                  id={`exchange_rate_brlusd_four_weeks`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="Câmbio USD 4W"
                  value={agreement.exchange_rate_brlusd_four_weeks}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="exchange_rate_brlusd_one_week">Câmbio USD 1W</InputLabel>
                <OutlinedInput
                  id={`exchange_rate_brlusd_one_week`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="Câmbio USD 1W"
                  value={agreement.exchange_rate_brlusd_one_week}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="exchange_rate_brlusd_today">Câmbio USD Hoje</InputLabel>
                <OutlinedInput
                  id={`exchange_rate_brlusd_today`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="Câmbio USD Hoje"
                  value={agreement.exchange_rate_brlusd_today}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
            </Box>

            <Box
              sx={{
                display: 'flex'
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="gdp_four_weeks">GDP 4W</InputLabel>
                <OutlinedInput
                  id={`gdp_four_weeks`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="GDP 4W"
                  value={agreement.gdp_four_weeks}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="gdp_one_week">GDP 1W</InputLabel>
                <OutlinedInput
                  id={`gdp_one_week`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="GDP 1W"
                  value={agreement.gdp_one_week}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="gdp_today">GDP Hoje</InputLabel>
                <OutlinedInput
                  id={`gdp_today`}
                  endAdornment={<InputAdornment position="end">%</InputAdornment>}
                  label="GDP Hoje"
                  value={agreement.gdp_today}
                  onChange={(event) => {
                    handleEditValues(event);
                  }}
                />
              </FormControl>
            </Box>
          </>
        }

      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSaveEditedValues()}>
            Salvar
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
